import { Component, Input } from '@angular/core';
import { GalleriaSpettacolo, Spettacolo } from '../../shared/interface';

import 'vidstack/player';
import 'vidstack/player/layouts/default';
import 'vidstack/player/ui';

@Component({
  selector: 'app-video-galleria-spettacolo',
  templateUrl: './video-galleria-spettacolo.component.html',
  styleUrl: './video-galleria-spettacolo.component.css'
})
export class VideoGalleriaSpettacoloComponent{

  constructor() {}
  
  @Input('spettacolo') spettacolo?:Spettacolo;
  @Input('file') file?: GalleriaSpettacolo;

}
